import { forwardRef, useId, type InputHTMLAttributes } from 'react';
import './Slider.css';

export interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Accessible label — required. E.g. the sample-size control referenced in
   * components.md ("e.g. sample-size control"). */
  label: string;
  /** Shows the current numeric value as visible text next to the label. */
  showValue?: boolean;
}

/** A real native `<input type="range">`, restyled — keeps native keyboard
 * behaviour (arrow keys, Home/End, Page Up/Down) for free. */
export const Slider = forwardRef<HTMLInputElement, SliderProps>(function Slider(
  { label, showValue = true, value, min = 0, max = 100, className, id, ...rest },
  ref
) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className="dpr-slider">
      <div className="dpr-slider__label-row">
        <label className="dpr-slider__label" htmlFor={inputId}>
          {label}
        </label>
        {showValue && value != null ? <span className="dpr-slider__value">{value}</span> : null}
      </div>
      <input
        ref={ref}
        type="range"
        id={inputId}
        min={min}
        max={max}
        value={value}
        className={['dpr-slider__input', className].filter(Boolean).join(' ')}
        {...rest}
      />
    </div>
  );
});
